// ItemSourceGuesser item workflow statuses
export enum ItemSourceGuesserItemStatus {
  PENDING = 0,
  NEEDS_USER_REVIEW = 1,
  DONE = 2,
}

// ItemSourceGuesser parent statuses
export enum ItemSourceGuesserStatus {
  PENDING = 3,
  NEEDS_USER_REVIEW = 5,
  DONE = 6,
}

// Shared async task status (same as backend AsyncTasksQueue)
export enum AsyncTaskStatus {
  PENDING = 0,
  DOING = 1,
  DONE = 2,
  FAILED = 3,
  DEAD_LETTER = 4,
  CANCELLED = 5,
  AWAITING_MEMORY = 6,
}

export const ItemSourceGuesserStatusLabels: Record<ItemSourceGuesserStatus, string> = {
  [ItemSourceGuesserStatus.PENDING]: 'pending',
  [ItemSourceGuesserStatus.NEEDS_USER_REVIEW]: 'needs_user_review',
  [ItemSourceGuesserStatus.DONE]: 'done',
};

export const ItemSourceGuesserItemStatusLabels: Record<ItemSourceGuesserItemStatus, string> = {
  [ItemSourceGuesserItemStatus.PENDING]: 'pending',
  [ItemSourceGuesserItemStatus.NEEDS_USER_REVIEW]: 'needs_user_review',
  [ItemSourceGuesserItemStatus.DONE]: 'done',
};

